module.exports = __webpack_public_path__ + "img/blue-safe.6c6dc4c3.svg";